import { render, staticRenderFns } from "./ShowTableCommitmentComponent.vue?vue&type=template&id=13cbd82b"
import script from "./ShowTableCommitmentComponent.vue?vue&type=script&lang=js"
export * from "./ShowTableCommitmentComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports